/**
 * 一覧の行に「下書きに戻す」 を出すか (AC-BSP-117 / AC-BSP-129)。 通常入札 (申請セット単位) と
 * ブロック入札 (グループ単位) で共通。 受け付けるかは backend の応答 (returnableToDraft: 送信中で
 * 入札締切前) で決まる。 取下と同じく、 応答の後に入札締切を跨いだ場合と、 確定済ワークフロー経由の
 * 読み取り専用だけを重ねて見る。
 */
export const canReturnToDraft = ({
  target,
  isBeforeDeadline,
  isWorkflowReadonly,
}: {
  target: { returnableToDraft?: boolean }
  isBeforeDeadline: boolean
  isWorkflowReadonly: boolean
}): boolean =>
  target.returnableToDraft === true && isBeforeDeadline && !isWorkflowReadonly
